import _ from 'lodash'
import initialValues from '../../Form/lib/initialValues'

export default ({ name }, value) => (
  _.get(initialValues, name) === _.toNumber(value)
)
